import HousekeepingStatusBoardDispatcher from "../dispatcher/HousekeepingStatusBoardDispatcher";

const HousekeepingStatusBoardConstants = {
  CHANGE_EVENT: 'change',
  INIT: 'INIT',
  GOTO_DATE: 'GOTO_DATE',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_LOADING: 'SET_LOADING',
  UPDATE_BOARD_DATA: 'UPDATE_BOARD_DATA',
  EXPAND_COLLAPSE_ROOM_TYPE: 'EXPAND_COLLAPSE_ROOM_TYPE'
};

export default HousekeepingStatusBoardConstants;

